import { useCallback as t } from "react";
import { getCopilotFileDownloadUrl as e, getCopilotFilesDownloadUrls as n } from "../file-download.js";
function c(o) {
  const r = t(
    async (l) => await e(o, l),
    [o]
  ), a = t(
    async (l) => await n(o, l),
    [o]
  );
  return {
    getFileDownloadUrl: r,
    getFilesDownloadUrls: a
  };
}
export {
  c as useCopilotFileDownload
};
